module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("CHAPTER "), _c('span', {
    staticClass: "big"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/ch.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chtitle"
  }, [_vm._v("George Woodward Morse")]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("George Woodward Morse ca. 1846–1847. Courtesy of Atlanta History Center.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("George Woodward Morse was an eighth-generation American of English descent. The American patriarch of the family was Anthony Morse, who immigrated to New England in 1635. Stephen Morse, George’s grandfather, was among the first settlers of Haverhill, New Hampshire, where George was born."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_1",
      "id": "fn1_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Bryan Morse, George’s father, was a blacksmith, cabinetmaker, staunch abolitionist, and preacher in the Methodist Episcopal Church in Haverhill. He married twice. With his first wife, Susannah Stevens, he had six children, including George, and with his second wife, Eliza D. Torr Repill, there were three offspring."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_2",
      "id": "fn1_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" We know very little about the relationship between Bryan and his children, but the four who moved to Louisiana in the 1830s held views of slavery that were diametrically opposed to Bryan’s. Reflecting the division within the family concerning slavery, the "), _c('i', [_vm._v("New Hampshire Gazette")]), _vm._v(" printed in 1850 that George’s older brother, Peabody, had emigrated many years ago to New Orleans, “where he forgot all his father’s counsels, who was an early and zealous abolitionist.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_3",
      "id": "fn1_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Though George became a strong advocate for both the personal and public ownership of slaves, he maintained a relationship with his father until the late 1850s and with his brother, Isaac, until well after the end of the Civil War.")]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Haverhill Academy, Haverhill, New Hampshire, where George W. Morse was educated. By permission of Haverhill Historical Society.")])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Reverend Bryan Morse (1781–1863), George’s father. He was a blacksmith, cabinetmaker, Methodist Episcopal preacher, and zealous abolitionist. Four of his children spent most of their adult lives as slaveholders in Louisiana. Courtesy of Atlanta History Center.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many writers incorrectly claim a close relationship between George W. Morse and Samuel Finley Breese Morse, coinventor of the Morse code. The error originated in George’s obituary and was perpetuated in a variety of journals and publications."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_4",
      "id": "fn1_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" One of George’s attorneys, James A. Skilton, wrote in 1872 that George was the namesake and relative of S. F. B. Morse, who had died that April. Skilton was probably embellishing the relationship between the two men so that the U.S. Congress would look favorably upon Morse’s current appeals for extension of his patents."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_5",
      "id": "fn1_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" George, himself, never claimed a close relationship. In all likelihood, the two men’s common ancestor was Anthony Morse, George’s great-great-great-great-grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George and his five full siblings, Horace Bassett, Peabody Atkinson, Priscilla Peabody, Isaac Stevens, and Rebecca Carleton, were born in Haverhill. All but Horace played a role in George’s adult life. His three half-siblings—Joseph, Mary, and Virginia—were the children of Bryan and Eliza; they were all born in Haverhill and all died at a young age in the 1820s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The oldest, Horace Bassett, was born in 1804. He was graduated from Dartmouth in 1823 and was the principal of Portsmouth Academy when he died in a drowning accident in Portsmouth Harbor in 1825 at the age of twenty-one."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_6",
      "id": "fn1_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" The family was soon divided. George’s father; his brother, Isaac; and probably his sisters moved to Lowell, Massachusetts, in 1833. George’s father later moved to Groveland, Massachusetts, where he died in 1863."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_7",
      "id": "fn1_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Also in the early 1830s, Peabody began what would become a family migration to "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Louisiana, and eventually Priscilla, Rebecca, and George joined him in a settled lifestyle there by 1840.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though the fifth-born sibling, Isaac Steven, remained in Massachusetts, he played a significant role in George’s later life. He attended Dartmouth College and Cambridge Law School, was admitted to the bar in 1840, practiced law in Lowell and Cambridge, Massachusetts, and was district attorney for Middlesex County from 1855 to 1871."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_8",
      "id": "fn1_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Highly respected in his profession, Isaac maintained contact with George well into the 1870s, assisting him in his postwar lawsuits against the federal government.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Peabody Atkinson Morse was the second-born and was seven years older than George. His major influence on the family was that he led three of his siblings, including George, to a life in Louisiana. Peabody was born in 1805 in Haverhill and was graduated from Dartmouth College in the class of 1830."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_9",
      "id": "fn1_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" From 1830 to 1833 he lived in Fredericksburg, Virginia, where he studied law under Virginia Court of Appeals justice Francis Taliaferro Brooke."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_10",
      "id": "fn1_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Peabody established a law practice in Natchitoches, Louisiana, about 1833."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_11",
      "id": "fn1_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" He married Virginia Sompayrac in 1837 and established the nearby town of Ninock the same year. Peabody served in the Louisiana House of Representatives and rose to the rank of major general in the Louisiana Militia."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_12",
      "id": "fn1_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" About 1849, Peabody moved to San Francisco, California, where he served as chief justice of the Superior Court of San Francisco in 1850 and 1851."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_13",
      "id": "fn1_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" By August 1855 Peabody moved back to Louisiana, where he remained active in politics and in managing his wife’s large estates until his death in 1878."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_14",
      "id": "fn1_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" George’s two younger sisters, Priscilla and Rebecca, followed Peabody to Natchitoches in the 1830s and, in 1840, both married Virginia Sompayrac’s brothers, deepening the Morse family roots in northwest Louisiana. Priscilla, born in 1814, married Adolphe Sompayrac, and Rebecca, born in 1820, married Paul Victor Sompayrac. George soon joined his siblings in Louisiana.")]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Peabody Atkinson Morse (1805–1878), George’s brother, photograph taken ca. 1858–59. Peabody was a Louisiana attorney, chief justice of the Superior Court of San Francisco, and major general in the Louisiana militia. Courtesy of Atlanta History Center.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("George was born in Haverhill, New Hampshire, on May 10, 1812, the third-born child."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_15",
      "id": "fn1_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" He was named for his father’s good friend and prominent Haverhill attorney and banker, George Woodward (August 20, 1776–December 5, 1836)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_16",
      "id": "fn1_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" George Morse was educated at the Haverhill Academy, the extent of his formal education. He displayed mechanical and inventive skills at an early age. His personal letters and professional reports from the 1840s through the 1870s reflect a man of intelligence, education, and creativity. Morse’s grammar, vocabulary, and mastery of the complex technical aspects of the disciplines of surveying and civil engineering seem to reflect a college education, though he had none.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Various family traditions and undocumented claims state incorrectly that George moved to Louisiana in the early 1830s when, in fact, he was living in Boston and England until very late in the decade."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_17",
      "id": "fn1_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" The correct version of events comes from an affidavit written in 1870 by George’s brother and Boston-area attorney, Isaac, and a deposition given by George in 1872."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_18",
      "id": "fn1_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" George testified that he worked with Captain Eliphalet Smith in Quincy Point, Massachusetts, in 1829 or 1830, when he was seventeen or eighteen years old. In 1830 or 1831, George moved to Boston to work with Otis Tufts, a machinist who invented a steam pile driver. After only fifteen months of employment, Morse was foreman of Tufts’s machine shop making steam engines, printing presses, and running gear for railroad cars. Morse even lived in Tufts’s home in 1834 and 1835."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_19",
      "id": "fn1_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was during his years spent with Tufts that Morse began to acquire experience with mechanical processes. His obituary states, “as a boy [he] identified with labor-saving inventions and manufactures in Boston.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_20",
      "id": "fn1_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Morse assisted Tufts in the development of a simplified printing press that could print eighteen sheets per minute. When they added steam power to the new machine, it became the first steam-powered printing press in the United States. Tufts introduced the new machine to the public, and Morse set it up in various Boston offices and even learned to print books on it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_21",
      "id": "fn1_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Because the new press was so promising, a group of capitalists planned to apply for patents in England and delegated Morse as their representative."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_22",
      "id": "fn1_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Accompanying the new invention, Morse sailed for London about 1835 on a two-year journey that exposed him to high-ranking British officials and engineers who would later play a role in the development of his firearms. The printing press proved to be such a labor-saving machine that some workmen intentionally damaged it to prevent its coming into general use. Morse repaired it and subsequently printed three novels by the Irish author Marguerite Gardiner, Countess of Blessington, and a popular annual she edited in 1837 called the "), _c('i', [_vm._v("Keepsake")]), _vm._v(". Building on his success in England, Morse made a contract with noted engineer brothers George and Sir John Rennie of Blackfriars Road, London, to manufacture one hundred presses. While still in London, Morse worked on a new steam engine, which brought him into contact with a noted American inventor, Jacob Perkins; a Scottish diplomat, Lord Napier; and another famous English engineer, I. K. Brunel. During that time the Rennies offered Morse an annual salary of five hundred pounds if he would remain as superintendent of their machine works, but he declined the offer."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_23",
      "id": "fn1_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Between 1830 and 1837, Morse developed from an eighteen-year-old machinist’s apprentice into a twenty-five-year-old young man who had helped develop a new invention with worldwide practical applications and had accompanied the device across the ocean as its sole representative. His contact with Tufts provided him with two critical experiences. First, it allowed him to acquire practical skills and knowledge of manufacturing processes which led to his later inventions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_24",
      "id": "fn1_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Second, it fostered his inventive spirit and allowed him to participate in a highly successful invention from concept to market. His sojourn in England provided him with invaluable experience in explaining innovative, complicated technology to skeptics, and in becoming comfortable around men of wealth, power, and professional stature. These experiences paid off in the late 1850s when he was trying to get the U.S. government to see the remarkable features of his new breechloader and its accompanying metallic, center-fire cartridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a two-year stay in London, Morse arrived in New York onboard the packet ship "), _c('i', [_vm._v("St. James")]), _vm._v(" on December 27, 1837."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_25",
      "id": "fn1_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" He soon joined Peabody, Priscilla, and Rebecca in Natchitoches. A gap in our knowledge of Morse’s exact whereabouts exists for the years 1838 and 1839, but he was likely living in Louisiana at that time. Isaac recalled after the Civil War that George returned to the United States about 1839 and soon moved to Louisiana."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_26",
      "id": "fn1_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" It is possible that George made a second trip to England in 1838 or 1839, but more likely Isaac remembered the date incorrectly. A search of city directories from England between 1836 and 1840 did not reveal Morse’s name. We know that George was living in Louisiana in 1840."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_27",
      "id": "fn1_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" The U.S. Congress passed an act on September 4, 1841, giving land to the state of Louisiana. The Louisiana secretary of state appointed Morse as one of the agents to locate the land, and Morse accepted the position on May 30, 1842."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_28",
      "id": "fn1_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" He served as a deputy U.S. surveyor in the Northwestern District of Louisiana for the remainder of the decade."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_29",
      "id": "fn1_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morse married a young widow, Marianne Bludworth Terrett, on June 26, 1848, at Trinity Episcopal Church in Natchitoches."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_30",
      "id": "fn1_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" He was a thirty-six-year-old Methodist Episcopal, and she was a twenty-three-year-old Catholic. The marriage would last until George’s death forty years later. Marianne was born in Natchitoches on October 11, 1824, and had married a Virginian, Burdett Ashton Terrett, in 1840. Marianne delivered her first-born at Jefferson Barracks, near St. Louis, Missouri, on May 18, 1842."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_31",
      "id": "fn1_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Terrett was captain of Company A, First United States Dragoons, stationed at Fort Scott, Kansas, when, on March 17, 1845, he was killed by the accidental discharge of his pistol while dismounting his horse."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_32",
      "id": "fn1_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Their second child, James Bludworth Terrett, died at the age of one month on March 1, 1845, only two weeks before Terrett’s death. The grieving widow and her son, Burdett Ashton Terrett Jr., soon returned to live with her family in Natchitoches, where she married Morse three years later."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_33",
      "id": "fn1_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both George and Marianne brought land and slaves into the marriage."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_34",
      "id": "fn1_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" After having lived for less than ten years in Louisiana, George owned twelve slaves and had acquired a three-hundred-acre plantation on Fausse River, another parcel of land on Bayou Saline, and a four-hundred-acre tract in Caddo Parish on the Red River."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_35",
      "id": "fn1_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Marianne owned a half-share in a seven-hundred-acre plantation with her brother, Poitevent Bludworth Jr., on Old River, also called Sabine River, in Natchitoches Parish. She also owned a half-share in seventeen slaves and another three outright."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_36",
      "id": "fn1_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Nat, a thirty-year-old slave living on Marianne’s plantation, was a carpenter, and was with Morse at the State Works from "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("1862 until the end of the war. In 1850 George was a surveyor in Natchitoches, and he owned twenty-five slaves and real estate valued at twenty thousand dollars."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_37",
      "id": "fn1_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("George Woodward Morse and his wife, Marianne Bludworth Terrett Morse, are shown in this daguerreotype made about 1853–54. George is holding Lelia in his lap, and Peabody is to the left of his mother, who is pregnant with their third child, Bryan. Courtesy of Atlanta History Center.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marianne bore six children."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_38",
      "id": "fn1_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Her first husband was the father of two, an unnamed infant and Burdett Terrett Jr., who lived with his mother and stepfather, George, until he went off to the U.S. Military Academy at West Point in 1860. When the war broke out, he refused to take the oath of allegiance to the United States and left the academy on April 22, 1861, to side with the South."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_39",
      "id": "fn1_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Burdett was severely wounded at the Battle of Shiloh but survived the war. He died in Natchitoches in 1874 and was buried at the American Cemetery there. Morse was the father of three children, and we do not know which man fathered the sixth, who probably died in infancy. Peabody Atkinson Morse was born in Natchitoches in 1849, served as a private in Company A, Second Regiment, Louisiana Cavalry, and died in Louisiana in 1872. Lelia Evariste Morse was born in 1851 in Natchitoches and never married. She died in Washington, D.C., on October 2, 1914, and was buried there at Oak Hill Cemetery near her mother and father. Bryant Herbert Morse, probably named for George’s father, was born in 1854 in Louisiana and died in Washington, D.C., in 1920."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_40",
      "id": "fn1_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At some time during the years George lived in Louisiana, he was a colonel in the Fifth Brigade, Louisiana Militia, which his brother, Peabody, commanded, but it is not known "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("how long he served. Morse only occasionally used the title of “colonel.” Workers at the South Carolina State Works referred to him as such, and in April 1874 he presented a fifteen-page memorial to the Forty-third U.S. Congress under the name “Colonel George W. Morse.” But when he presented another memorial to the Forty-fourth Congress only two years later, he did not use any military rank. Likewise, in numerous letters and documents signed by Morse, he did not refer to himself as “colonel.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_41",
      "id": "fn1_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Louisiana governor Joseph M. Walker appointed the forty-year-old Morse to the post of state engineer of Louisiana, or as Morse described it, chief engineer for the state of Louisiana, in 1852."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_42",
      "id": "fn1_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Morse implied in his 1853 annual report that he assumed the office sometime between March 1852 and April 1853 and stated in 1877 that he served as chief engineer under Walker, who left office in January 1853."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_43",
      "id": "fn1_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" According to Walker’s successor, Paul Octave Hebert, Morse was state engineer for the years 1853 and 1854."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_44",
      "id": "fn1_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Morse’s office was in Baton Rouge, and George and Marianne made the 150-mile move from Natchitoches to the state capital probably by the spring of 1853. As state engineer, Morse reported to Louisiana legislators and socialized with his neighbor Governor Hebert, gaining additional experience that would serve him well in future personal dealings with high-ranking men. As state engineer, Morse had widespread responsibilities. He managed the office efficiently and on a tight budget. In 1853 he recommended repeal of a one-year-old law that allowed the state engineer a thousand-dollar contingency fund for travel and office expenses, stating that his office would be run strictly on a voucher system and would always be prepared to account for its expenses. Morse demanded a strict accounting of all disbursements, requiring all orders to be copied into an order book and all letters to be recorded. He insisted that, in his absence from the office, a good clerk be available to handle urgent matters. Morse did plan to travel, not only to make the surveys and examinations of waterways as required by the legislature, but also to oversee and direct the state workforce to make it as useful as possible. In his years as state engineer, Morse developed a distinct managerial style; ten years later in South Carolina he would clash with David Lopez over Lopez’s management skills, which Morse considered to be inferior to his own and inadequate to manage the State Works.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morse’s primary responsibility as state engineer was to supervise the removal of obstacles to navigation in the state’s waterways using both white and slave labor. Building and maintaining canal locks, levees, bridges, and roads as well as surveying and examining waterways also fell within his purview. Morse advocated expanding the labor force primarily by the use of slave labor. In 1855 he recommended that the state enlarge his department from one hundred slaves to four hundred."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_45",
      "id": "fn1_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morse had only one boat at his disposal in April 1853 when he recommended that the State spend ten thousand dollars to build two new snag-boats, which were shallow-draft, steam-powered barges equipped with cranes and thick hawsers used to dislodge waterway obstructions. Displaying his creative mechanical inclinations, he wrote, “In construction of the new boats, I wish to make some improvements in the model and working machinery, which I believe will not only enable them to move from one portion of the State to the other with facility, but to be efficient when at work.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_46",
      "id": "fn1_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" In January 1854 he wrote about submerged obstructions that the snag-boat was unable to remove from a river bottom: “I have already a machine planned which I intend to apply to them, that will have sufficient force either to pull them up or pull the boat under water.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_47",
      "id": "fn1_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" By 1854 both boats "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("were under construction. Morse was persistent, and by January 1855 he had a total of four boats either in service or soon to be."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_48",
      "id": "fn1_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Morse also experimented with underwater blasting to clear waterways of floating rafts of debris, submerged stumps, and sunken boats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morse made annual reports in 1853, 1854, and 1855. Displaying an air of self-confidence that would continue to manifest itself throughout the rest of his life, he wrote in his January 1854 report, “I am convinced that great good has been accomplished here in a very short time.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_49",
      "id": "fn1_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Though no records exist, it appears that 1855 was Morse’s last year as Louisiana state engineer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sometime in 1854 or 1855, Morse began to envision the firearm and cartridge that would permanently alter his life and significantly affect the future development of firearms. When he applied for his first patent, in January 1856, Morse was living in Baton Rouge."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_50",
      "id": "fn1_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" By July of that year he had a new job as commissioner for the First Swamp Land District, a position he would later describe as chief, or chairman, of the Board of Swamp Land Commissioners, whose function was to secure the reclamation of overflowed lands in the state."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_51",
      "id": "fn1_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" He later recalled that, in spite of Governor Hebert’s pleas for him to remain in Louisiana, he was determined to have the government adopt his new gun for military service. Though he held the title until mid-1858, Morse effectively gave up the job as swamp commissioner when he went to West Point for gun trials in the summer of 1857."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn1_52",
      "id": "fn1_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eb647f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/08_Chapter01.vue
// module id = 78
// module chunks = 0